import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoanNotes } from "@app/models/loan-notes";
import { LoansNotesService } from "@app/services/loans-notes.service";

@Component({
    selector: "app-loan-note-node",
    templateUrl: "./loan-note-node.component.html",
    styleUrls: ["./loan-note-node.component.css"],
    standalone: false
})
export class LoanNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() loanNotes: Array<LoanNotes>;
  @Input() selectedLoanNotes: Array<LoanNotes>;
  @Output() onAddLoanNote = new EventEmitter<LoanNotes>();
  @Output() onDeleteLoanNote = new EventEmitter<LoanNotes>();

  constructor(private loanNoteService: LoansNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addLoanNote(item);
    } else {
      this.deleteLoanNote(item);
    }
  }

  addLoanNote(item) {
    this.onAddLoanNote.emit(item);
  }

  deleteLoanNote(item) {
    this.onDeleteLoanNote.emit(item);
  }

  isSelectedLoanNote(item: LoanNotes): boolean {
    if (!this.selectedLoanNotes || !item) {
      return false;
    }
    return this.selectedLoanNotes.some((p) => p && p.id === item.id);
  }

  isIndeterminate(item: LoanNotes): boolean {
    if (!item || !item.subLoanNotes || item.subLoanNotes.length === 0) {
      return false;
    }
    if (this.isSelectedLoanNote(item)) {
      return false;
    }
    return this.hasSelectedDescendant(item);
  }

  isExpanded(item: LoanNotes): boolean {
    if (this.isSelectedLoanNote(item)) {
      return true;
    }
    return this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: LoanNotes): boolean {
    if (!item || !item.subLoanNotes || item.subLoanNotes.length === 0) {
      return false;
    }
    return item.subLoanNotes.some(
      (child) => this.isSelectedLoanNote(child) || this.hasSelectedDescendant(child)
    );
  }
}
